module.exports = __webpack_public_path__ + "media/assets/images/category/GetWell@2x-32f46bcc125edc750812de6ae3fa2ecb.png";